import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { Retiro, Venta } from '@/types/database'

export interface RetiroFiltros {
  estado?: 'pendiente' | 'parcial' | 'completo'
}

export function useRetiros(filtros: RetiroFiltros = {}) {
  return useQuery({
    queryKey: ['retiros', filtros],
    queryFn: () => {
      const params = new URLSearchParams({ limit: '200' })
      if (filtros.estado) params.set('estado', filtros.estado)
      return api.get<Retiro[]>(`/api/retiros?${params}`)
    },
    staleTime: 30_000,
  })
}

export function useVentasParaRetiro() {
  return useQuery({
    queryKey: ['ventas-para-retiro'],
    queryFn: () => api.get<Venta[]>('/api/ventas?limit=150'),
    staleTime: 30_000,
  })
}

export function useCrearRetiro() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ ventaId, items, notas }: {
      ventaId: string
      items: Array<{ ventaItemId: string; cantidadSolicitada: number }>
      notas: string
      usuarioId: string
    }) =>
      api.post<{ id: string; numero: number }>('/api/retiros', {
        venta_id: ventaId,
        notas:    notas.trim() || null,
        items: items.map(i => ({
          venta_item_id:       i.ventaItemId,
          cantidad_solicitada: i.cantidadSolicitada,
        })),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['retiros'] }),
  })
}

export function useRegistrarEntrega() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ retiroId, entregas }: {
      retiroId: string
      entregas: Array<{ itemId: string; cantidadEntregada: number }>
    }) =>
      api.put(`/api/retiros/${retiroId}/entrega`, {
        entregas: entregas.map(e => ({
          item_id:            e.itemId,
          cantidad_entregada: e.cantidadEntregada,
        })),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['retiros'] }),
  })
}
